import createPayment from '@/shared/api/orders/payments/createPayment';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import DialogName from '@/shared/types/dialogName.enum';
import { PaymentCreate } from '@/shared/types/order/payment.type';

import UpdateHandlers from '../../types/updateHandlers.type';
import useOrder from './useOrder';
import usePaymentMethodsAndStatuses from './usePaymentMethodsAndStatuses';

type Args = {
  orderDetailsState: ReturnType<typeof useOrder>;
  dialogProps: UpdateHandlers<unknown>;
};

const useCheckoutPayments = ({ orderDetailsState, dialogProps }: Args) => {
  const redirectLogin = useRedirectLogin();

  const paymentDetails = usePaymentMethodsAndStatuses();

  const handleCreatePayment = async (
    transactionAmount: string,
    paymentMethod: 'CASH' | 'EXTERNAL',
  ) => {
    orderDetailsState.setRefetchOrder(false);

    dialogProps.onUpdateProgressDialog({
      open: true,
      title: 'Processing Payment',
    });

    const paymentObj: PaymentCreate = {
      in_order_id: orderDetailsState.order?.in_order_id || '',
      status: paymentDetails.statuses['APPROVED'],
      payment_method: paymentDetails.methods[paymentMethod],
      transaction_amount: transactionAmount,
    };

    const response = await createPayment({
      body: paymentObj,
      onUnauthorized: redirectLogin,
    });

    dialogProps.onUpdateProgressDialog({ open: false });

    if (response.success) {
      orderDetailsState.setRefetchOrder(true);

      dialogProps.onUpdateDialogState(DialogName.CashPayment, {
        open: false,
      });
      dialogProps.onUpdateDialogState(DialogName.ExternalTerminalPayment, {
        open: false,
      });
      dialogProps.onUpdateNotificationBar({
        open: true,
        message: 'The Payment was successfully proceeded',
      });
    } else {
      dialogProps.onUpdateDialogState(DialogName.CashPayment, {
        errors: [response.msg],
      });
      dialogProps.onUpdateDialogState(DialogName.ExternalTerminalPayment, {
        errors: [response.msg],
      });
    }
  };

  return {
    handleCreatePayment,
  };
};

export default useCheckoutPayments;
